export enum UserPermissions {
    BasicOrientation = 'BasicOrientation',
    BatchFunctions = 'BatchFunctions',
    CanChangeSurveyVersionOfInvite = 'CanChangeSurveyVersionOfInvite',
    CanOverrideStyleOfInvite = 'CanOverrideStyleOfInvite',
    CanViewMidRangeChoices = 'CanViewMidRangeChoices',
    CanViewPrivateResults = 'CanViewPrivateResults',
    CanViewSurveyInvites = 'CanViewSurveyInvites',
    CanViewSurveyReportTypes = 'CanViewSurveyReportTypes',
    CanViewSurveyResults = 'CanViewSurveyResults',
    CognitiveFocus = 'CognitiveFocus',
    Comparison = 'Comparison',
    CreateTeams = 'CreateTeams',
    Edit9Box = 'Edit9Box',
    EditFusionScore = 'EditFusionScore',
    EditScores = 'EditScores',
    EditUsers = 'EditUsers',
    ExchangeNotes = 'ExchangeNotes',
    Grid = 'Grid',
    GridCategories = 'GridCategories',
    Foundations = 'Foundations',
    ListView = 'ListView',
    ListViewRI = 'ListViewRI',
    ManageAllTeams = 'ManageAllTeams',
    PVAReport = 'PVAReport',
    ReceivesSurveyCompleteEmails = 'ReceivesSurveyCompleteEmails',
    RFactorReport = 'RFactorReport',
    RFactorReportMidRanges = 'RFactorReportMidRanges',
    ScoreBarColorChange = 'ScoreBarColorChange',
    SecondaryScale = 'SecondaryScale',
    SendAssessments = 'SendAssessments',
    TeamReport = 'TeamReport',
    Teamology = 'Teamology',
    TeamologyTertiaryAccess = 'TeamologyTertiaryAccess',
    View9Box = 'View9Box',
    ViewAllCandidates = 'ViewAllCandidates',
    ViewAllFormerEmployees = 'ViewAllFormerEmployees',
    ViewAllUsers = 'ViewAllUsers',
    ViewAssessmentNotes = 'ViewAssessmentNotes',
    ViewFusionScore = 'ViewFusionScore',
    ViewMidRanges = 'ViewMidRanges',
    ViewResponseIndicatorsAndBreakdown = 'ViewResponseIndicatorsAndBreakdown',
    ViewTeams = 'ViewTeams',
}

export const getUserPermissionDescription = (permission: string): string => {
    const normalized = permission.charAt(0).toUpperCase() + permission.slice(1);
    return UserPermissionDescriptions[normalized as UserPermissions] || '';
};

const UserPermissionDescriptions: { [key in UserPermissions]?: string } = {
    [UserPermissions.BatchFunctions]: 'Allows batch actions such as sending invites, creating logins, and batch PDF exports.',
    [UserPermissions.CanChangeSurveyVersionOfInvite]: 'Allows changing the survey version on an invite.',
    [UserPermissions.CanOverrideStyleOfInvite]: 'Allows overriding the style associated with an invite.',
    [UserPermissions.CanViewMidRangeChoices]: 'Allows viewing the available mid-range choice options.',
    [UserPermissions.CanViewSurveyReportTypes]: 'Allows viewing and selecting survey report types.',
    [UserPermissions.CanViewSurveyResults]: 'Allows viewing survey invite details and possibly survey results.',
    [UserPermissions.CreateTeams]: 'Allows creating teams.',
    [UserPermissions.Edit9Box]: 'Allows editing within the 9-Box report.',
    [UserPermissions.EditScores]: 'Allows editing scores and accessing score editing tools.',
    [UserPermissions.EditUsers]: 'Allows access to user management and editing users.',
    [UserPermissions.ExchangeNotes]: 'Allows access to Exchange Notes.',
    [UserPermissions.Grid]: 'Enables access to the Team Grid report.',
    [UserPermissions.Foundations]: 'Makes the individual report a descriptive guide with no charts or scores.',
    [UserPermissions.ListView]: 'Enables access to the Team List View report.',
    [UserPermissions.ListViewRI]: 'Enables access to the Team List View RI report.',
    [UserPermissions.ManageAllTeams]: 'Allows managing all teams in scope, not just assigned teams.',
    [UserPermissions.RFactorReport]: 'Enables access to the R Factor report.',
    [UserPermissions.ScoreBarColorChange]: 'Allows changing or toggling score bar colors in charts.',
    [UserPermissions.SendAssessments]: 'Allows sending survey assessments and invites.',
    [UserPermissions.TeamReport]: 'Enables access to the Team Report.',
    [UserPermissions.Teamology]: 'Enables access to the Teamology report.',
    [UserPermissions.TeamologyTertiaryAccess]: 'Allows access to the Tertiary Style option in Teamology.',
    [UserPermissions.View9Box]: 'Enables access to the 9-Box report.',
    [UserPermissions.ViewAllCandidates]: 'Allows viewing all candidates.',
    [UserPermissions.ViewAllFormerEmployees]: 'Allows viewing all former employees.',
    [UserPermissions.ViewAllUsers]: 'Allows viewing all users instead of only the normal team scope.',
    [UserPermissions.ViewAssessmentNotes]: 'Allows viewing assessment notes in reports.',
    [UserPermissions.ViewFusionScore]: 'Enables access to the Score Card / Fusion Score feature.',
    [UserPermissions.ViewMidRanges]: 'Allows access to mid-range report views.',
    [UserPermissions.ViewResponseIndicatorsAndBreakdown]: 'Allows viewing response indicators and response breakdown details.',
    [UserPermissions.ViewTeams]: 'Allows access to view teams.',
};



// WEBPACK FOOTER //
// ./src/models/UserPermissions.tsx